export default __webpack_public_path__ + "static/media/2.963b1a00.svg";